import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router-dom'
import InternalLink from 'components/views/internalLink/InternalLink';

import './header.scss';
import FaSignOut from 'react-icons/lib/fa/sign-out';
import UserImage from 'views/userImage/UserImage';
import TenantImage from 'views/tenantImage/TenantImage';
import Select from 'views/select/Select';
import FlashMessages from 'views/flashMessages/FlashMessages';

import authStore from 'storeState/auth';
import tenantsStore from 'storeState/tenants';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';

import URLService from 'service/URLService';

import _ from 'lodash';


export class Header extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    replaceLang = (lang) => {
        if (typeof window === 'undefined') {
            return `/${lang}`;
        }
        const arr = window.location.pathname.split('/');
        let newUrl = '';
        for (let i = 0; i < arr.length; i++) {
            if (i === 1) {
                newUrl += lang;
            } else {
                newUrl += arr[i];
            }
            if (i !== arr.length - 1) {
                newUrl += '/';
            }
        }
        return newUrl;
    }

    renderHeaderItem = ({to, title}) => {
        return(
            <InternalLink to={to} >
                {title}
            </InternalLink>
        );
    }

    componentWillMount = () => {
        if(this.props.loginData && this.props.loginData.tenant_role=="admin") {
            this.props.actions.tenantsListRequest();
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.loginData != this.props.loginData) {
            if(nextProps.loginData && nextProps.loginData.tenant_role=="admin") {
                nextProps.actions.tenantsListRequest();
            }
        }
    }

    onLogout = () => {
        this.props.actions.logoutRequest();
    }

    onTenantSelect = (tenant_id) => {
        URLService.setQueryParameter("tenant_id", tenant_id);
    }

    getTenantOptions = () => {
        return _.map(this.props.tenants || [], (t) => {
            return {
                value: t.id,
                label: t.name,
            }
        })
    }

    handleProfileClick = () => {
        URLService.gotoPush("/users?user_id="+this.props.loginData.id);
    }

    render() {
        const {formatMessage} = this.context.intl;
        const loginData = this.props.loginData;

        return (
            <div className={`page-header`}>
                <FlashMessages/>
                <img className={"logo-small"} src={require("assets/images/actidoo-a.png")} />
                <InternalLink to={`/`} className="page-header-logo">
                  Esperandoo
                </InternalLink>

                <If condition={this.props.isLoggedIn}>
                  <div className={`page-header-link-container`}>
                      {this.renderHeaderItem({
                          to:'/dashboard',
                          title: formatMessage({id: "header.menu.dashboard", defaultMessage:"Dashboard"})
                      })}

                      <If condition={this.props.loginData.tenant_role=="admin"}>
                          {this.renderHeaderItem({
                              to:'/projects',
                              title: formatMessage({id: "header.menu.projects", defaultMessage:"Projects"})
                          })}

                          {this.renderHeaderItem({
                              to:'/users',
                              title: formatMessage({id: "header.menu.users", defaultMessage:"Users"})
                          })}
                      </If>

                      <If condition={this.props.loginData.global_role=="admin"}>
                          {this.renderHeaderItem({
                              to:'/tenants',
                              title: formatMessage({id: "header.menu.tenants", defaultMessage:"Tenants"})
                          })}
                      </If>
                  </div>
                </If>

                {/*<div className={`page-header-language-container`}>
                    <Link to={this.replaceLang('de')}>DE</Link>
                    <Link to={this.replaceLang('en')}>EN</Link>
                </div>*/}

                <If condition={this.props.isLoggedIn}>
                  <div className="page-header-greeting">
                      <div className="page-header-greeting-tenant-image">
                          <TenantImage user={loginData} />
                      </div>
                      <div className="page-header-greeting-tenant">
                          <If condition={this.props.loginData.global_role=="admin"}>
                              <Select
                                  className="header-select"
                                  options={this.getTenantOptions()}
                                  value={this.props.currentTenantId}
                                  onChange={(val) => this.props.actions.setCurrentTenantId({tenant_id: val ? val.value : null})}
                              />
                          <Else />
                              {loginData.tenant_name}
                          </If>
                      </div>
                      <div className="page-header-greeting-user" onClick={this.handleProfileClick}>
                          <div className="page-header-greeting-avatar" onClick={this.handleProfileClick}>
                              <UserImage user={loginData} />
                          </div>
                          <div className="page-header-greeting-username" onClick={this.handleProfileClick}>
                              {loginData.username}
                          </div>
                      </div>
                  </div>
                  <div className={`page-header-other-buttons-container`}>
                      <div title={formatMessage({id:"header.logout.title", defaultMessage:"Logout"})}>
                        <FaSignOut onClick={this.onLogout} size={30}></FaSignOut>
                      </div>
                  </div>
                <Else />

                </If>
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    isLoggedIn: authStore.selectors.isLoggedIn(state),
    loginData: authStore.selectors.loginData(state),
    tenants: tenantsStore.selectors.tenantsList(state),
    currentTenantId: authStore.selectors.currentTenantId(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, authStore.actions, tenantsStore.actions), dispatch)
  }
})(Header)



// WEBPACK FOOTER //
// ./src/components/views/header/Header.js